import React, { useState, createContext } from 'react';

export const InboxContext = createContext({
    titleId: '',
    isLiteFormat: false,
    setLiteFormat: () => {}
});

export const InboxContextProvider = ( { children }) => {
    const [isLiteFormat, setLiteFormat] = useState(false);
    const titleId = 'common.notices';
    const value = { isLiteFormat, setLiteFormat, titleId: titleId };

    return (
        <InboxContext.Provider value={value}>{children}</InboxContext.Provider>
    );
};
